import { useContext, useEffect, useState } from 'react'
import { Typography } from '@mui/material'

import { AppContext } from '/providers/app-context'
import StyledPaper from '/components/paper'
import { getCreditMatrix } from '/providers/studio-api'

const CreditMatrix = () => {
  const { apiSource, apiKey } = useContext(AppContext)
  const [matrix, setMatrix] = useState([])

  useEffect(() => {
    loadMatrix()
  }, [])

  const loadMatrix = async () => {
    const result = await getCreditMatrix({ apiSource, apiKey })
    if (result.ok) setMatrix(result.matrix)
  }

  return (
    <StyledPaper>
      <div className='flex flex-col gap-5 p-5 items-center'>
        <div className='flex flex-col gap-5 p-3 items-center max-w-[800px]'>

          <Typography variant="h3">Credit / cost matrix</Typography>

          <p>Credit costs are the same across all plans (Pay-as-you-go and monthly plans)</p>

          <table className="border">
            <thead>
              <tr>
                <th className="border text-nowrap p-3 text-left">Pass type</th>
                <th className="border text-nowrap p-3">Issue</th>
                <th className="border text-nowrap p-3">Update</th>
                <th className="border text-nowrap p-3">Patch</th>
                <th className="border text-nowrap p-3">Patch 2+ passes *</th>
                <th className="border text-nowrap p-3">Notify</th>
                <th className="border text-nowrap p-3">Notify 2+ passes *</th>
                <th className="border text-nowrap p-3">Verify</th>
                <th className="border text-nowrap p-3">Credit</th>
                <th className="border text-nowrap p-3">Debit</th>
              </tr>
            </thead>
            <tbody>
              {matrix.map(item => (
                <tr key={item.pass_type}>
                  <td className="border p-3 text-nowrap capitalize">{item.pass_type}</td>
                  <td className="border p-3 text-center">{item.issue}</td>
                  <td className="border p-3 text-center">{item.update}</td>
                  <td className="border p-3 text-center">{item.patch}</td>
                  <td className="border p-3 text-center">{item.patch_multi}</td>
                  <td className="border p-3 text-center">{item.notify}</td>
                  <td className="border p-3 text-center">{item.notify_multi}</td>
                  <td className="border p-3 text-center">{item.verify}</td>
                  <td className="border p-3 text-center">{item.credit}</td>
                  <td className="border p-3 text-center">{item.debit}</td>
                </tr>
              ))}
            </tbody>

          </table>

          <div className="flex flex-col gap-2">
            <p><strong>*</strong> : Use notifyPasses, notifyAllPasses, patchPasses, patchAllPasses rather that notifyPass and patchPass for reduced credit use wheb applying the same change/notification to multiple passes.</p>
            <p><strong>Verify</strong> : Managed loyalty and stamp cards and be self-issued by your customers. We charge you when ongoing usage has been verified by being used on a date other than the date it was issued. This means you do not pay for any unused passes.</p>
            <p><strong>Credit</strong> : We do not charge for points / stamps being credited to managed loyalty and stamp cards.</p>
            <p><strong>Debit</strong> : We charge a small credit fee when points / stamps are redeemed (debited from the pass).</p>
          </div>
        </div>

      </div>
    </StyledPaper>
  )
}

export default CreditMatrix
